import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './contexts/languagecontext';
import QuizApp from './quiz_management/quizapp.js';
import AdminMainRoutes from './admin/adminroutes';  // NEW: Main admin dashboard
import QAStudyInterface from './pages/qastudyinterface';
import StudentStudyMaterial from './study_material/StudentStudyMaterial';
import TeacherDashboard from './pages/teacherdashboard';

// Import pages
import StudentLogin from './pages/studentlogin';  
import StudentDashboard from './pages/studentdashboard'; 
import StudentProtectedRoute from './pages/studentprotectedroute';
import HomePage from './pages/homepage';
import TeachingMode from './pages/teachingmode';
import DoubtSolvingMode from './pages/doubtsolvingmode';
import EnhancedLearningInterface from './pages/enhancedlearninginterface';
import TopicsSubtopicsInterface from './pages/topicssubtopicsinterface';
import BulkUploadManager from './bulk_upload/BulkUploadManager';
import StudentProfile from './pages/studentprofile';  // ← Add this import
import TeacherLogin from './pages/teacherlogin';
import LiveQuizTeacherPanel from './livequiz/LiveQuizTeacherPanel';
import LiveQuizStudentEntry from './livequiz/LiveQuizStudentEntry';
import StudentNewLearningEntry from './pages/StudentNewLearningEntry';

// Import hamburger menu component
import HamburgerMenu from './components/navigation/hamburgermenu';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes - No hamburger menu */}
            <Route path="/" element={<StudentLogin />} />
            <Route path="/login" element={<StudentLogin />} />
            <Route path="/dashboard" element={
              <StudentProtectedRoute>
                <StudentDashboard />
              </StudentProtectedRoute>
            } />

             {/* ADD THIS NEW ROUTE */}
            <Route path="/profile" element={
              <StudentProtectedRoute>
                <StudentProfile />
              </StudentProtectedRoute>
            } />
            
            {/* NEW: Replace old admin with new admin dashboard */}
            <Route path="/admin/*" element={<AdminMainRoutes />} />
            
            {/* Student Routes - With hamburger menu */}
            <Route path="/home" element={
              <StudentProtectedRoute>
                <>
                  <HamburgerMenu />
                  <main><HomePage /></main>
                </>
              </StudentProtectedRoute>
            } />
            
            <Route path="/teaching" element={
              <StudentProtectedRoute>
                <>
                  <HamburgerMenu />
                  <main><TeachingMode /></main>
                </>
              </StudentProtectedRoute>
            } />
            
            <Route path="/doubt-solving" element={
              <StudentProtectedRoute>
                <>
                  <HamburgerMenu />
                  <main><DoubtSolvingMode /></main>
                </>
              </StudentProtectedRoute>
            } />
            
            <Route path="/enhanced-chunks" element={
              <StudentProtectedRoute>
                <>
                  <HamburgerMenu />
                  <main><EnhancedLearningInterface /></main>
                </>
              </StudentProtectedRoute>
            } />
            
            <Route path="/topics-subtopics" element={
              <StudentProtectedRoute>
                <>
                  <HamburgerMenu />
                  <main><TopicsSubtopicsInterface /></main>
                </>
              </StudentProtectedRoute>
            } />

            {/* NEW: Bulk Upload Route */}
            <Route path="/admin/bulk-upload" element={
              <>
                <HamburgerMenu />
                <main><BulkUploadManager /></main>
              </>
            } />
            
            <Route path="/quiz" element={
              <StudentProtectedRoute>
                <>
                  <HamburgerMenu />
                  <main><QuizApp /></main>
                </>
              </StudentProtectedRoute>
            } />

            <Route path="/practice-qa" element={
              <StudentProtectedRoute>
                <>
                  <HamburgerMenu />
                  <main><QAStudyInterface /></main>
                </>
              </StudentProtectedRoute>
            } />

            <Route path="/study-material" element={
              <StudentProtectedRoute>
                <>
                  <HamburgerMenu />
                  <main><StudentStudyMaterial /></main>
                </>
              </StudentProtectedRoute>
            } />

            <Route path="/new-learning" element={
  <StudentProtectedRoute>
    <>
      <HamburgerMenu />
      <main><StudentNewLearningEntry /></main>
    </>
  </StudentProtectedRoute>
} />

<Route path="/teacher/login" element={<TeacherLogin onLoginSuccess={() => window.location.href = '/teacher/dashboard'} />} />

<Route path="/teacher/dashboard" element={<TeacherDashboard />} />

            <Route path="/teacher/livequiz" element={
              <LiveQuizTeacherPanel teacherToken={localStorage.getItem('teacherToken')} />
            } />

            <Route path="/livequiz" element={
              <StudentProtectedRoute>
                <>
                  <HamburgerMenu />
                  <main><LiveQuizStudentEntry /></main>
                </>
              </StudentProtectedRoute>
            } />

            </Routes>
        </div>
      </Router>
    </LanguageProvider>  
  );
}

export default App;